<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Project/POA/components/Calendar/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>